import React from 'react';
import ApplicationListItem from './ApplicationListItem';
import InfiniteScroll from 'react-infinite-scroller';
import { /*Image, */ Segment } from 'semantic-ui-react';
import CompressedImage from '../../../app/common/elements/CompressedImage';
import { Fragment } from 'react';

export default function ApplicationList({
  applications,
  getNextApplications,
  loadingInitial,
  loading,
  moreApplications,
  showAdvanced,
  isSearch,
}) {
  const images = [
    '/assets/images/error1_300.png',
    '/assets/images/error2_300.png',
    '/assets/images/notFound1_300.png',
    '/assets/images/notFound2_300.png',
    '/assets/images/notFound3_300.png',
  ];

  const randomNumber = Math.floor(Math.random() * 5);
  const imgURL = images[randomNumber];

  return (
    <Fragment>
      {applications && applications.length !== 0 && !isSearch && (
        <InfiniteScroll
          pageStart={0}
          loadMore={getNextApplications}
          hasMore={!loading && moreApplications}
          initialLoad={false}
        >
          {applications.map((application) => (
            <ApplicationListItem
              key={application.id}
              application={application}
              showAdvanced={showAdvanced}
            />
          ))}
        </InfiniteScroll>
      )}
      {applications && applications.length === 0 && !loadingInitial && (
        <Segment>
          <h3 style={{ textAlign: 'center' }}>
            I looked, but I couldn't find anything!"
          </h3>

          <CompressedImage
            webp={true}
            jxr={true}
            jpf={true}
            src={imgURL}
            style={{
              display: 'flex',
              height: 'auto',
              width: 'auto',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          />

          <h3 style={{ textAlign: 'center' }}>
            Try changing the filters to see if you can find something else!
          </h3>
        </Segment>
      )}
    </Fragment>
  );
}
